import { useQuery } from "@tanstack/react-query";
import { useStore } from "../../../helpers";
import {
  CANVAS_LIST_DEFAULT_LIMIT,
  CANVAS_LIST_DEFAULT_OFFSET,
  TARS_CANVAS_LIST_PATH,
} from "../tars-constants";

export interface CanvasListItem {
  id: number;
  name: string;
  type?: string;
  [key: string]: unknown;
}

export interface ListCanvasesResponse {
  canvases?: CanvasListItem[];
  [key: string]: unknown;
}

export interface ListCanvasesParams {
  notebook_id: number;
  search?: string;
  type?: string;
  offset?: number;
  limit?: number;
}

export const useCanvasList = (
  notebookId: number | null,
  enabled: boolean,
  options?: { search?: string; type?: string; offset?: number; limit?: number }
) => {
  const rootStore = useStore();
  const isEnabled = Boolean(
    enabled && notebookId != null && !Number.isNaN(notebookId)
  );
  const offset = options?.offset ?? CANVAS_LIST_DEFAULT_OFFSET;
  const limit = options?.limit ?? CANVAS_LIST_DEFAULT_LIMIT;
  const search = options?.search ?? "";
  const type = options?.type ?? "";

  return useQuery({
    queryKey: ["tars", "canvas", "list", notebookId, search, type, offset, limit],
    queryFn: async () => {
      const body: ListCanvasesParams = {
        notebook_id: notebookId!,
        search,
        type,
        offset,
        limit,
      };
      const res = await rootStore.apiRequestHandler(
        TARS_CANVAS_LIST_PATH,
        body,
        "Failed to list canvases"
      );
      return (res.data ?? res) as ListCanvasesResponse;
    },
    enabled: isEnabled,
  });
};
